import { create } from 'zustand';
import { createBrandingDataSlice, type BrandingDataSlice } from './brandingDataSlice';

export type AppState = BrandingDataSlice;

export const useAppStore = create<AppState>()((set, get) => ({
  ...createBrandingDataSlice(set, get),
}));
